import axios from '@/http/index';

const base = '';
// 新增员工请假/休假
export const postLeaveStaff = (params) => axios.post(`${base}/erp/vacation/saveOrUpdate`, params).then((res) => res.data);

// 5.4erp展示轮牌
export const getErpTechnicianCard = (params) => axios.get(`${base}/erp/lookTechnicianCard/getErpTechnicianCard`, params).then((res) => res.data);

// 5.4erp展示项目列表
export const getItemByMainId = (params) => axios.get(`${base}/erp/lookTechnicianCard/getItemByMainId`, params).then((res) => res.data);

// 5.4erp扣牌
export const deductCard = (params) => axios.get(`${base}/erp/lookTechnicianCard/deductCard`, params).then((res) => res.data);

// 5.4erp下牌
export const downCard = (params) => axios.get(`${base}/erp/lookTechnicianCard/downCard`, params).then((res) => res.data);

// 5.4erp跳牌
export const jumpCard = (params) => axios.get(`${base}/erp/lookTechnicianCard/jumpCard`, params).then((res) => res.data);

// 5.4erp复牌
export const resumeCard = (params) => axios.get(`${base}/erp/lookTechnicianCard/resumeCard`, params).then((res) => res.data);

// 5.4erp上牌
export const upCard = (params) => axios.get(`${base}/erp/lookTechnicianCard/upCard`, params).then((res) => res.data);

// 5.7erp轮牌名称列表
export const getCardsByMainId = (params) => axios.get(`${base}/erp/lookTechnicianCard/getCardsByMainId`, params).then((res) => res.data);
